import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksJournalEntryFields', {
    currency: 'Currency',
    journalNumber: 'Journal #',
    journalDate: 'Journal date',
    memo: 'Memo',
});
